/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { computed } from '@ember/object';
import { isNone } from '@ember/utils';
import ActionModel from 'cio/models/action';

interface VisualWorkflowBuilderWorkflowActionSplitNameArgs {
  action: ActionModel;
}

export default class VisualWorkflowBuilderWorkflowActionSplitName extends Component<VisualWorkflowBuilderWorkflowActionSplitNameArgs> {
  // conditional_branch_action
  @computed('args.action.{type,conditions}')
  get conditions() {
    if (this.args.action.type !== 'conditional_branch_action') {
      return [];
    }

    if (isNone(this.args.action.conditions)) {
      return [];
    }

    return this.args.action.conditions;
  }
}
